/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { BrokenRule } from "./broken-rule";
// May contain unused imports in some cases
// @ts-ignore
import { DocumentLine } from "./document-line";

/**
 *
 * @export
 * @interface OrderLineModelDocumentModel
 */
export interface OrderLineModelDocumentModel {
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedAmountDue?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedAmountPretax?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedPriceBeforePrepaidDiscount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedSumAmount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedSumAmountPrepaidDiscount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedSumAmountPretax?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedSumAmountValue?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CalculatedSumQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrderLineModelDocumentModel
   */
  ContractAcceptanceShow?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  AccrualAmount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  AccrualQuantity?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ActualCarrierCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  Amount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  AmountDue?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  AmountPaid?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ApprovalStatus?: OrderLineModelDocumentModelApprovalStatusEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Approver1?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Approver2?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  BillToAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  BillToCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  BLComments?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  CardCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  CardName?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  CarrierCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ClosingRemarks?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Comments?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContactPersonCode?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractAmountCommitted?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractAmountPrepaid?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractAmountPrepaidInvoiced?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractAmountPrepaidOrdered?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractAmountPrepaidRemaining?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ContractDate?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ContractTime?: string;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractLineNumber?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractNumber?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractQuantityCommitted?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractQuantityDelivered?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractQuantityInvoiced?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractQuantityOrdered?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractQuantityOrderedOpen?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractQuantityRemaining?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ContractReferenceNumber?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ContractStatus?: OrderLineModelDocumentModelContractStatusEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ContractType?: OrderLineModelDocumentModelContractTypeEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  CreateDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  CreateUser?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  CreateUserSign?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  CustomsBrokerCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DangerousGoods?: OrderLineModelDocumentModelDangerousGoodsEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DeliveryDate?: string;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountAmount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountAmount1?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountAmount2?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountAmount3?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountPercent?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountPercent1?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountPercent2?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DiscountPercent3?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DocDate?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DocDueDate?: string;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DocEntry?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DocSent?: string | null;
  /**
   *
   * @type {Array<DocumentLine>}
   * @memberof OrderLineModelDocumentModel
   */
  DocumentLines?: Array<DocumentLine> | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DocumentNumber?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DocumentStatus?: OrderLineModelDocumentModelDocumentStatusEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DocumentType?: OrderLineModelDocumentModelDocumentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DraftDocEntry?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  DriverName?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  DuplicateReleaseNumber?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  EquipmentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Exchange?: OrderLineModelDocumentModelExchangeEnum;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  FormId?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  FreightAllowanceAmount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  FreightChargeAmount?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  FreightTermsCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  FuelSurchargePercent?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ImportExport?: OrderLineModelDocumentModelImportExportEnum;
  /**
   *
   * @type {boolean}
   * @memberof OrderLineModelDocumentModel
   */
  IsCanceled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderLineModelDocumentModel
   */
  IsDraft?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  LoadScaleTicketComments?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  MasterBill?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ModeOfTransportationCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  NumAtCard?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ObjectType?: OrderLineModelDocumentModelObjectTypeEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  OpeningRemarks?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PAPS?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PaymentMethodCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  PaymentTermsCode?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  Placards?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PortOfEntryCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  PostedPrice?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PrebuyDate1?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PrebuyDate2?: string;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  PrebuyPercent1?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  PrebuyPercent2?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  PriceBeforePrepaidDiscount?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Printed?: OrderLineModelDocumentModelPrintedEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PrintLoadScaleTicket?: OrderLineModelDocumentModelPrintLoadScaleTicketEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PrintProforma?: OrderLineModelDocumentModelPrintProformaEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  PrivateEquipment?: OrderLineModelDocumentModelPrivateEquipmentEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ProjectCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ReferenceDocEntry?: number;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  ReleaseNumber?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  RequiredDate?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Route?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  SalespersonCode?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  SalesTermsCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  SealNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  SeriesCode?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ShipDateEnd?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ShipDateStart?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ShipperName?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ShipToAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ShipToCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  StorageAmount?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  StorageDate?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  SummaryType?: OrderLineModelDocumentModelSummaryTypeEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  SupplierReleaseNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  TaxAmount?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  TaxDate?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  TimeIn?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  TimeOut?: string;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  TradeNumber?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  Transfer?: OrderLineModelDocumentModelTransferEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  UpdateDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  UpdateUser?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  UpdateUserSign?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  AcceptanceStatus?: OrderLineModelDocumentModelAcceptanceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ValidDate?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ValidTime?: string;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  ValidTimeZone?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  SearchItemShortName?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderLineModelDocumentModel
   */
  SearchQuantity?: number;
  /**
   *
   * @type {string}
   * @memberof OrderLineModelDocumentModel
   */
  SearchWarehouseCode?: string | null;
  /**
   *
   * @type {Array<BrokenRule>}
   * @memberof OrderLineModelDocumentModel
   */
  BrokenRules?: Array<BrokenRule> | null;
}

/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelApprovalStatusEnum {
  None = "None",
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Generated = "Generated",
  GeneratedByApprover = "GeneratedByApprover",
  Cancelled = "Cancelled",
  Without = "Without",
  TreasuryToUpdate = "TreasuryToUpdate",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelContractStatusEnum {
  None = "None",
  Open = "Open",
  Closed = "Closed",
  Pending = "Pending",
  Canceled = "Canceled",
  Offer = "Offer",
  Request = "Request",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelContractTypeEnum {
  None = "None",
  Prebuy = "Prebuy",
  PriceQuote = "PriceQuote",
  Regular = "Regular",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelDangerousGoodsEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelDocumentStatusEnum {
  None = "None",
  Open = "Open",
  Closed = "Closed",
  Paid = "Paid",
  Delivered = "Delivered",
  OpenPrinted = "OpenPrinted",
  Canceled = "Canceled",
  Unapproved = "Unapproved",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelDocumentTypeEnum {
  None = "None",
  Item = "Item",
  Service = "Service",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelExchangeEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelImportExportEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelObjectTypeEnum {
  None = "None",
  OBusinessPartners = "oBusinessPartners",
  OItems = "oItems",
  OInvoices = "oInvoices",
  OCreditNotes = "oCreditNotes",
  ODeliveryNotes = "oDeliveryNotes",
  OReturns = "oReturns",
  OOrders = "oOrders",
  OPurchaseInvoices = "oPurchaseInvoices",
  OPurchaseCreditNotes = "oPurchaseCreditNotes",
  OPurchaseDeliveryNotes = "oPurchaseDeliveryNotes",
  OPurchaseReturns = "oPurchaseReturns",
  OPurchaseOrders = "oPurchaseOrders",
  OQuotations = "oQuotations",
  OIncomingPayments = "oIncomingPayments",
  Deposit = "Deposit",
  OJournalEntries = "oJournalEntries",
  OVendorPayments = "oVendorPayments",
  OInventoryGenEntry = "oInventoryGenEntry",
  OInventoryGenExit = "oInventoryGenExit",
  OWarehouses = "oWarehouses",
  AtdtCorrectionInvoice = "atdtCorrectionInvoice",
  OProductionOrders = "oProductionOrders",
  ODownPayments = "oDownPayments",
  OPurchaseDownPayments = "oPurchaseDownPayments",
  InternalReconciliation = "InternalReconciliation",
  AtdtInventoryPosting = "atdtInventoryPosting",
  AtdtInventoryOpeningBalance = "atdtInventoryOpeningBalance",
  OPurchaseQuotations = "oPurchaseQuotations",
  OPurchaseQuotationGroups = "oPurchaseQuotationGroups",
  TrialBalanceFloQastReport = "TrialBalanceFloQastReport",
  TrialBalanceFloQast2Report = "TrialBalanceFloQast2Report",
  AtdtInventoryCounting = "atdtInventoryCounting",
  NotImplemented = "NotImplemented",
  CancelledReconcilliation = "CancelledReconcilliation",
  Bn = "BN",
  ClosingBalance = "ClosingBalance",
  OpeningBalance = "OpeningBalance",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelPrintedEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
  Amended = "Amended",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelPrintLoadScaleTicketEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelPrintProformaEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelPrivateEquipmentEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelSummaryTypeEnum {
  None = "None",
  NoSummary = "NoSummary",
  ByItems = "ByItems",
  ByDocuments = "ByDocuments",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelTransferEnum {
  None = "None",
  No = "No",
  Yes = "Yes",
}
/**
 * @export
 * @enum {string}
 */
export enum OrderLineModelDocumentModelAcceptanceStatusEnum {
  None = "None",
  NotRequired = "NotRequired",
  Required = "Required",
  PendingAcceptance = "PendingAcceptance",
  Accepted = "Accepted",
  Expired = "Expired",
  Canceled = "Canceled",
  AlreadyAccepted = "AlreadyAccepted",
}
